import React, { useEffect, useState } from "react";
import { Box } from "rebass";
import Autocomplete from "../../icons/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import { yodaOrdersActions } from "../../logic/actions";
import { filter } from "lodash";
import { BsEraser } from "react-icons/bs";
import { BsArrowBarRight } from "react-icons/bs";

function AutocompleteButton({ id, door, color, element, config }) {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(0);
  const { order, orderRowDetails } = useSelector((state) => state.yodaOrders);
  const {
    catalogue,
    catalogueItemDetails,
    catalogueItemDetailsSwap,
    itemCatalog,
  } = useSelector((state) => state.yodaCatalogue);

  const { me } = useSelector((state) => state.yodaStakeholders);

  const [isCustomerCare, setIsCustomerCare] = useState(false);

  useEffect(() => {
    if (me?.role.includes?.("CustomerCare")) {
      setIsCustomerCare(true);
    }
  }, [me]);

  useEffect(() => {
    order?.customData?.doors?.map((d, idx) => {
      let catalogId;

      catalogue
        ?.filter((c) => c.productId === id)
        .forEach((c) => {
          if (!catalogId) {
            const hit = c.catalog.find((cc) => cc.colorCode === element?.code);
            if (hit) {
              catalogId = hit.catalogId;
            }
          }
        });

      if (!catalogId) {
        catalogId = catalogueItemDetails[id]?.catalog.filter(
          (f) => f.colorCode == element?.code,
        )[0]?.catalogId;
      }
      if (!catalogId) {
        catalogId = catalogueItemDetailsSwap[id]?.catalog.filter(
          (f) => f.colorCode == element?.code,
        )[0]?.catalogId;
      }
      if (!catalogId) {
        catalogId = Object.keys(itemCatalog).find(
          (k) => itemCatalog[k].colorCode === element?.code,
        );
      }
      let tmpArr = filter(
        orderRowDetails,
        (k, v) =>
          k.catalogId == catalogId &&
          door == k.customData.doorId &&
          k.customData.typeId == config,
      );

      let quantity = 0;
      // let price = 0;

      tmpArr.forEach((e) => {
        quantity += e.currentQuantity;
        // price += e.price;
      });

      setQuantity(quantity);
    });
  }, [
    catalogueItemDetails,
    catalogue,
    element?.code,
    id,
    order?.customData?.doors,
    orderRowDetails,
    quantity,
    itemCatalog,
  ]);

  function autocomplete() {
    let matchKey = [id, color, door].join("_");
    let keys = Object.keys(document.externalPinPadHandle).filter(
      (f) => f.match(matchKey) !== null,
    );
    const qnt = quantity ? 0 : 1;

    let dataArr = [];
    keys.forEach((k) => {
      qnt
        ? dataArr.push(document.externalPinPadHandle[k].getUpdateModel(qnt))
        : dataArr.push(
            document.externalPinPadHandle[k].getAutocancelledModel(),
          );
    });

    dispatch(yodaOrdersActions.concurrentUpdateRowAuto(dataArr));
  }

  return (
    <Box
      onClick={autocomplete}
      style={{ transform: "scale(0.6)", cursor: "pointer" }}
      sx={{
        "& > svg > g > g > g": { fill: "#C1C1C1", stroke: "#C1C1C1" },
        "& > svg > g > g > path": { stroke: "#C1C1C1" },
      }}
    >
      {isCustomerCare &&
        (quantity > 0 ? (
          <BsEraser size="38px" color="#666666" />
        ) : (
          <BsArrowBarRight size="38px" color="#666666"></BsArrowBarRight>
        ))}
    </Box>
  );
}

export { AutocompleteButton };
